import pino from 'pino';

const pinoLogger = pino({
  formatters: {
    level(level) {
      return { level };
    },
  },
});

export const logger = {
  info(message: string, data: unknown) {
    pinoLogger.info(data, message);
  },
  warn(message: string, data: unknown) {
    pinoLogger.warn(data, message);
  },
  error(message: string, error: unknown) {
    pinoLogger.error(error, message);
  },
};
